<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
          <template slot="header">
            <div class="row">
              <div class="col-md-6">
                <h4 class="card-title">Ore di lavoro</h4>
              </div>
              <div class="col-md-6">
                <fg-input type="date"
                          label="Giorno"
                          :disabled="saving"
                          v-model="giorno">
                </fg-input>
              </div>
            </div>
          </template>
          <p v-if="loading" class="card-category">
          <center>{{ loadingText }}</center>
          </p>
          <div class="row" v-if="!loading">
            <div class="table-ore-lavoro" :style="{'padding-bottom':'90px','max-width':'100%','max-height':Math.max(200,window.height-200)+'px'}">
              <vue-scrolling-table class="table" deadAreaColor="#FFF">
                <template slot="thead">
                  <tr>
                    <th style="width:160px !important;min-width:160px !important;max-width:160px !important;"></th>
                    <th style="width:120px !important;min-width:120px !important;max-width:120px !important;"><b>Acconto</b></th>
                    <th style="width:120px !important;min-width:120px !important;max-width:120px !important;" v-for="lav in lavorazioni">{{ lav.lavorazione }}</th>
                    <th style="width:120px !important;min-width:120px !important;max-width:120px !important;"><b>Totale</b></th>
                  </tr>
                </template>
                <template slot="tbody" style="padding-bottom: 150px;">
                  <tr v-for="dip in dipendenti">
                    <td style="width:160px !important;min-width:160px !important;max-width:160px !important;">{{ dip.nome }} {{ dip.cognome }}</td>

                    <td style="width:120px !important;min-width:120px !important;max-width:120px !important;white-space: nowrap; overflow:visible;">
                  <fg-input type="number"
                            v-bind:class="{'ore-lavoro': true,'ore-lavoro-hide-text':(acconti[dip.id]==0), 'ore-lavoro-disabled': saving}"
                            v-model="acconti[dip.id]"
                            />
                  </td>

                  <td v-for="lav in lavorazioni" style="width:120px !important;min-width:120px !important;max-width:120px !important;white-space: nowrap; overflow:visible;">
                    <!--                        <vue-timepicker
                                              v-bind:class="{'ore-lavoro': true,'ore-lavoro-hide-text':(lavoro[dip.id][lav.id]['H']==0 && lavoro[dip.id][lav.id]['mm']==0), 'ore-lavoro-disabled': saving}"
                                              v-model="lavoro[dip.id][lav.id]"
                                              format="H:mm"
                                              :minute-interval="15"
                                              hide-clear-button
                                              />-->


                  <Orario 
                    v-bind:class="{'ore-lavoro': true,'ore-lavoro-hide-text':(lavoro[dip.id][lav.id]==0), 'ore-lavoro-disabled': saving}"
                    v-model="lavoro[dip.id][lav.id]"
                    />

                  <!--                        <fg-input type="text"
                                                    v-bind:class="{'ore-lavoro': true,'ore-lavoro-hide-text':(lavoro[dip.id][lav.id]==0), 'ore-lavoro-disabled': saving}"
                                                    v-model="lavoro[dip.id][lav.id]"
                                                    />-->
                  </td>
                  <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-totali">{{ getTotaleDipendente(dip.id) }}</td>
                  </tr>
                  <tr>
                    <td style="width:160px !important;min-width:160px !important;max-width:160px !important;"><b>Totale</b></td>
                    <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-totali"></td>
                    <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" v-for="lav in lavorazioni" class="ore-lavoro-totali">{{ getTotaleLavorazione(lav.id) }}</td>
                    <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" class="ore-lavoro-totali">{{ getTotaleGenerale() }}</td>
                  </tr>
                </template>
              </vue-scrolling-table>
            </div>
            <div style="width:100%; min-height:90px; margin-top:-90px;">
              <center style="color:red; font-weight:bold;">{{ erroreSalvataggio }}</center>
            </div>
            <div class="col-md-12 text-right">
              <button type="button" :disabled="saving" class="btn btn-info btn-fill" @click.prevent="salva">
                Salva
              </button>
            </div>
          </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import VueScrollingTable from 'vue-scrolling-table'
  import Orario from './Orario.vue'

  export default {
    components: {
      Card,
      VueScrollingTable,
      Orario
    },
    data () {
      return {
        countCaricaGiorno: 0,
        saving: false,
        erroreSalvataggio: '',
        loading: true,
        loadingText: 'Caricamento in corso...',
        backendPath: 'ore-lavoro/report-giorno',
        giorno: null,
        dipendenti: [],
        lavorazioni: [],
        lavoro: [],
        acconti: [],
        window: {
          width: 0,
          height: 0
        }
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
      var me = this
      me.$data.giorno = me.todayToString()
    },
    watch: {
      giorno (value) {
        var me = this
        me.caricaGiorno(value)
      }
    },
    methods: {
      handleResize () {
        this.window.width = window.innerWidth
        this.window.height = window.innerHeight
      },
      resettaData () {
        var me = this
        me.$data.loading = true
        me.$data.loadingText = 'Caricamento in corso...'
        me.$data.backendPath = 'ore-lavoro/report-giorno'
        me.$data.dipendenti = []
        me.$data.lavorazioni = []
        me.$data.lavoro = []
      },
      caricaGiorno: function (giorno) {
        var me = this
        me.resettaData()
        var countCaricaGiorno = ++me.$data.countCaricaGiorno
        if (!giorno) {
          return
        }
        var url = process.env.API_URL + me.$data.backendPath + '/' + giorno
        var method = 'GET'
        var params = {}
        var successFn = function (data) {
          if (countCaricaGiorno !== me.$data.countCaricaGiorno) {
            return
          }
          var lavoro = {}
          for (var d in data.dipendenti) {
            var idD = data.dipendenti[d].id
            lavoro[idD] = {}
            for (var l in data.lavorazioni) {
              var idL = data.lavorazioni[l].id
              var h, m
              if (typeof data.minuti[idD] === 'undefined' || typeof data.minuti[idD][idL] === 'undefined') {
                h = 0
                m = 0
              } else {
                m = data.minuti[idD][idL] % 60
                h = (data.minuti[idD][idL] - m) / 60
              }
              if (m < 10) {
                m = '0' + m
              }
              if (h === 0) {
                h = '0'
              }
              lavoro[idD][idL] = h + ':' + m
            }
          }
          me.$data.loading = false
          me.$data.dipendenti = data.dipendenti
          me.$data.lavorazioni = data.lavorazioni
          me.$data.lavoro = lavoro
          me.$data.acconti = data.acconti
        }
        var errorFn = function (message) {
          if (typeof message === 'undefined') {
            message = 'Network Error'
          }
          me.$data.loadingText = 'Errore: ' + message
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      },
      salva: function () {
        var me = this
        me.saving = true
        me.erroreSalvataggio = ''
        var minuti = {}
        var acconti = {}
        var giorno = me.$data.giorno
        var lavoro = me.$data.lavoro
        for (var idDip in lavoro) {
          for (var idLav in lavoro[idDip]) {
            if (lavoro[idDip][idLav]) {
              var min = 0
              var oreArray = []
              if (lavoro[idDip][idLav].indexOf(':') !== -1) {
                oreArray = lavoro[idDip][idLav].split(':')
              } else if (lavoro[idDip][idLav].indexOf('.') !== -1) {
                oreArray = lavoro[idDip][idLav].split('.')
              } else if (lavoro[idDip][idLav].indexOf(',') !== -1) {
                oreArray = lavoro[idDip][idLav].split(',')
              } else {
                oreArray = [0, lavoro[idDip][idLav]]
              }
              min = (parseInt(oreArray[0]) || 0) * 60 + (parseInt(oreArray[1]) || 0)
              if (min) {
                if (typeof minuti[idDip] === 'undefined') {
                  minuti[idDip] = {}
                }
                minuti[idDip][idLav] = min
              }
            }
          }
          acconti[idDip] = me.$data.acconti[idDip]
        }
        var url = process.env.API_URL + me.$data.backendPath + '/' + giorno
        var method = 'PUT'
        var params = {
          minuti: minuti,
          acconti: acconti
        }
        var successFn = function (data) {
          me.successMessage('Dati salvati')
          me.saving = false
        }
        var errorFn = function (message) {
          if (typeof message === 'undefined') {
            message = 'Network Error'
          }
          me.$data.erroreSalvataggio = 'Errore: ' + message
          me.saving = false
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      },
      getTotaleLavorazione (idLav) {
        var lavoro = this.$data.lavoro
        var tot = 0
        for (var idDip in lavoro) {
          if (lavoro[idDip][idLav]) {
            var oreArray = []
            if (lavoro[idDip][idLav].indexOf(':') !== -1) {
              oreArray = lavoro[idDip][idLav].split(':')
            } else if (lavoro[idDip][idLav].indexOf('.') !== -1) {
              oreArray = lavoro[idDip][idLav].split('.')
            } else if (lavoro[idDip][idLav].indexOf(',') !== -1) {
              oreArray = lavoro[idDip][idLav].split(',')
            } else {
              oreArray = [0, lavoro[idDip][idLav]]
            }
            tot += (parseInt(oreArray[0]) || 0) * 60 + (parseInt(oreArray[1]) || 0)
          }
        }
        var mTot = tot % 60
        var hTot = (tot - mTot) / 60
        if (mTot < 10) {
          mTot = '0' + mTot
        }
        return hTot + ':' + mTot
      },
      getTotaleDipendente (idDip) {
        var lavoro = this.$data.lavoro
        var tot = 0
        for (var idLav in lavoro[idDip]) {
          if (lavoro[idDip][idLav]) {
            var oreArray = []
            if (lavoro[idDip][idLav].indexOf(':') !== -1) {
              oreArray = lavoro[idDip][idLav].split(':')
            } else if (lavoro[idDip][idLav].indexOf('.') !== -1) {
              oreArray = lavoro[idDip][idLav].split('.')
            } else if (lavoro[idDip][idLav].indexOf(',') !== -1) {
              oreArray = lavoro[idDip][idLav].split(',')
            } else {
              oreArray = [0, lavoro[idDip][idLav]]
            }
            tot += (parseInt(oreArray[0]) || 0) * 60 + (parseInt(oreArray[1]) || 0)
          }
        }
        var mTot = tot % 60
        var hTot = (tot - mTot) / 60
        if (mTot < 10) {
          mTot = '0' + mTot
        }
        return hTot + ':' + mTot
      },
      getTotaleGenerale () {
        var lavoro = this.$data.lavoro
        var tot = 0
        for (var idDip in lavoro) {
          for (var idLav in lavoro[idDip]) {
            if (lavoro[idDip][idLav]) {
              var oreArray = []
              if (lavoro[idDip][idLav].indexOf(':') !== -1) {
                oreArray = lavoro[idDip][idLav].split(':')
              } else if (lavoro[idDip][idLav].indexOf('.') !== -1) {
                oreArray = lavoro[idDip][idLav].split('.')
              } else if (lavoro[idDip][idLav].indexOf(',') !== -1) {
                oreArray = lavoro[idDip][idLav].split(',')
              } else {
                oreArray = [0, lavoro[idDip][idLav]]
              }
              tot += (parseInt(oreArray[0]) || 0) * 60 + (parseInt(oreArray[1]) || 0)
            }
          }
        }
        var mTot = tot % 60
        var hTot = (tot - mTot) / 60
        if (mTot < 10) {
          mTot = '0' + mTot
        }
        return hTot + ':' + mTot
      }
    }
  }

</script>
<style>
  .ore-lavoro{
    width: 100% !important;
  }
  .ore-lavoro > input{
    cursor: pointer;
    width: 100% !important;
    text-align: right;
  }
  .ore-lavoro-hide-text > input{
    color:#FFF;
  }
  .ore-lavoro-disabled > input{
    pointer-events:none;
    background-color: #F5F5F5;
    color: #565656;
  }
  .ore-lavoro-disabled.ore-lavoro-hide-text > input{
    color: #F5F5F5;
  }
  .ore-lavoro-totali{
    text-align: right;
    font-weight: bold;
    padding: 12px 16px !important;
  }
  .table-ore-lavoro th{
    text-align: center !important;
  }

  .table-ore-lavoro thead td:first-child,
  .table-ore-lavoro tbody td:first-child,
  .table-ore-lavoro thead th:first-child,
  .table-ore-lavoro tbody th:first-child {
    position: sticky;
    position: -webkit-sticky;
    left: 0;
    z-index:1;
    background-color: #f7f7f7;
  }

  .table-ore-lavoro tbody {
    padding-bottom:100px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/OreLavoro.vue